<script setup lang="ts">
import { ref, computed } from '#imports';
import { UiPopper, UiPopperPlacement, type PopperStrategyType } from '../popper';

const props = withDefaults(defineProps<{
  placement?: UiPopperPlacement;
  defaultOpenHandler?: boolean;
  border?: boolean;
  disabled?: boolean;
  enableClickAway?: boolean;
  minWidth?: string;
  hover?: boolean;
  openDelay?: number;
  closeDelay?: number;
  strategy?: PopperStrategyType;
  auto?: boolean;
}>(), {
  placement: UiPopperPlacement.BottomEnd,
  defaultOpenHandler: true,
  border: true,
  disabled: false,
  enableClickAway: true,
  minWidth: '',
  hover: false,
  openDelay: 0,
  closeDelay: 0,
  auto: false,
});

const classView = computed(() => {
  return [props.border ? '_border' : ''];
});

const popperRef = ref(null);

defineSlots<{
  opener?(props: { open: () => void; close: () => void; isOpen: boolean; toggle: () => void; }): void;
  default?(props: { close: () => void; isOpen: boolean; }): void;
}>();

defineEmits(['close', 'open']);
</script>

<template lang="pug">
UiPopper.ui-dropdown(
  ref="popperRef"
  :class="classView"
  :disabled="disabled"
  :placement="placement"
  :defaultOpenHandler="defaultOpenHandler"
  :enableClickAway="enableClickAway"
  :minWidth="minWidth"
  :hover="hover"
  :openDelay="openDelay"
  :closeDelay="closeDelay"
  :strategy="strategy"
  :auto="auto"
  @close:popper="$emit('close')"
  @open:popper="$emit('open')"
)
  template(v-slot:opener="{ open, close, isOpen, toggle }")
    slot(name="opener" :open="open" :close="close" :toggle="toggle" :isOpen="isOpen")
  template(v-slot="{ close, isOpen }")
    .ui-dropdown-content
      slot(:close="close" :isOpen="isOpen")
</template>

<style lang="scss" scoped>
@import '../../styles/colors';

.ui-dropdown-content {
  overflow: hidden;
  --uno: br-8;
  background: white;
  box-shadow: 0px 7px 18px rgba(15, 0, 30, 0.15), 0px 0px 1px rgba(15, 0, 30, 0.15);
  max-width: 100vw;
}

.ui-dropdown {
  &._border {
    .ui-dropdown-content {
      border: 1px solid $ui-color-border-default;
    }
  }
}
</style>
